import get from 'lodash.get'
import { round } from '@/modules/utils'

const unitsInsideBatches = batches => batches.reduce((sum, batch) => sum + batch.units, 0)

const breakdownTooltip = (translations, directTemplate, directUnits, batches) =>
  batches.reduce(
    (text, batch) => `${text} ${batch.units < 0 ? '−' : '+'} ${translations.translate('tplVarianceCountedInsideBatch', { '{a}': round(Math.abs(batch.units), 2), '{b}': batch.title })}`,
    translations.translate(directTemplate, { '{a}': round(directUnits, 2) })
  )

export const countedInBatchesTooltip = (translations, total, batches) =>
  batches && batches.length ? breakdownTooltip(translations, 'tplVarianceCountedDirectly', Math.max(total - unitsInsideBatches(batches), 0), batches) : undefined

export const movedInBatchesTooltip = (translations, total, batches) => (batches && batches.length ? breakdownTooltip(translations, 'tplVarianceMovedDirectly', total - unitsInsideBatches(batches), batches) : undefined)

export const takenOut = batches => (batches || []).map(batch => ({ ...batch, units: -batch.units }))

export const netMovedInBatches = (movedInBatches, { includingDepletions = false } = {}) => {
  const signedColumns = [['invoices', 1], ['transfers_in', 1], ['returns', -1], ['transfers_out', -1], ...(includingDepletions ? [['depletions', -1]] : [])]
  const netByBatchItemId = {}
  signedColumns.forEach(([column, sign]) => {
    get(movedInBatches, column, []).forEach(batch => {
      const net = netByBatchItemId[batch.batch_item_id] || { ...batch, units: 0 }
      netByBatchItemId[batch.batch_item_id] = { ...net, units: net.units + sign * batch.units }
    })
  })
  return Object.values(netByBatchItemId).filter(batch => Math.abs(batch.units) > 1e-9)
}
